export enum ModalZone {
    "primary" = "primary",
    "secondary" = "secondary",
    "tercary" = "tercary",
}

export enum ModalKeys {
    wallet = "layout-wallet-modal",
    basket = "layout-basket-modal",
    productInfo = "product-info",
    campaignTakeOfflineConfirmation = "campaign-confirm-take-offline",
    campaignProductTakeOfflineConfirmation = "campaign-product-confirm-take-offline",
    campaignCopyJourney = "campaign-confirm-copy",
    campaignStatusDetail = "campaign-status-detail",
    campaignCopySelection = "contract-copy-selection",
    campaignEdit = "campaign-edit",
    basketRemoveProductConfirmation = "remove-product-from-basket",
    basketProductBundleParentClashConfirmation = "basket-product-bundle-parent-clash-confirmation",
    basketProductBundleChildClashConfirmation = "basket-product-bundle-child-clash-confirmation",
    contractRemoveConfirmation = "contract-remove-confirmation",
    contractEdit = "contract-edit",
    contractGroupConflictInfo = "contract-group-conflict-info",
    filePicker = "file-picker",
    contractPostingRequirementsSmartFillSuccess = "contract-posting-requirements-smart-fill-success",
    "mediaEditor" = "media-editor",
    "uploadWidget" = "upload-widget",
    "mediaLibrary" = "media-library",
}

export enum FilePickerModalPropsActionFor {
    postingOrganization = "posting-organization",
    postingRequirements = "posting-requirements",
}
